import React, { Component } from 'react';
import { connect } from 'react-redux';
import { DropdownV2, DataTable } from 'carbon-components-react';
import  Numeral  from 'numeral';
import 'numeral/locales/pt-br';
import _ from 'lodash';
import { TableDefault, SearchInput } from '../../../components';
import { getDmService } from '../../../services/Api';

const { TableToolbarContent } = DataTable;

const PERIOD_OPTIONS = [
  { id: '1', label: 'Período: 1 ano' },
  { id: '2', label: 'Período: 6 meses' },
  { id: '3', label: 'Período: 3 meses' },
  { id: '4', label: 'Período: 1 mês' },
  { id: '5', label: 'Período: 15 dias' },
  { id: '6', label: 'Período: 7 dias' },
];

class Budget extends Component {
  state = {
    period: PERIOD_OPTIONS[0],
    search: '',
    saldoAtual: 0
  };

  componentWillMount = () => {
    Numeral.locale('pt-br');
    this.getSaldoAtual()
  }

  getItems = () => this.listRef && this.listRef.getItems();

  getItemsDebounced = _.debounce(this.getItems, 500);

  getSaldoAtual = async () => {
    try {
      const data = await getDmService('/Orcamento/SaldoAtual');
      console.log("data saldo")
      console.log(data);
      const {saldoAtual} = data;
      this.setState({
        saldoAtual
      });
    } catch (error) {
      console.log(error)
    }
  }

  onSearchChange = event => {
    this.setState(
      {
        search: event.target.value,
      },
      () => {
        this.getItemsDebounced();
      },
    );
  };

  onPeriodChange = ({ selectedItem }) => {
    this.setState(
      {
        period: selectedItem,
      },
      () => {
        this.getItemsDebounced();
      },
    );
  };

  render() {
    const { period, search, saldoAtual } = this.state;
    const { user } = this.props;

    return (
      <div>
        <div className="bx--row">
          <div className="bx--col-xs-12">
            <div className="bx--col-inline v-md-margin">
              <h3>
                Saldo Atual:
                {' '}
                <strong>{Numeral(saldoAtual).format('$ 0.00')}</strong>
              </h3>
              <h3 style={{ marginLeft: '16px' }}>
                Saldo Mensal:
                {' '}
                <strong>{user && user.saldoMensal ? user.saldoMensal : 'R$ 0,00'}</strong>
              </h3>
            </div>
          </div>
        </div>
        <div className="v-md-margin">
          <div className="bx--row">
            <div className="bx--col-xs-12 bx--col-sm-6">
              <TableToolbarContent style={{ display: 'block' }}>
                <div className="bx--row">
                  <div className="bx--col-xs-12 bx--col-sm-6">
                    <DropdownV2
                      label=""
                      defaultText="Período"
                      items={PERIOD_OPTIONS}
                      initialSelectedItem={PERIOD_OPTIONS[0]}
                      onChange={this.onPeriodChange}
                    />
                  </div>
                  <div className="bx--col-xs-12 bx--col-sm-6">
                    <SearchInput placeholder="Filtrar" onChange={this.onSearchChange} />
                  </div>
                </div>
              </TableToolbarContent>
            </div>
          </div>
          <TableDefault
            onRef={ref => {
              this.listRef = ref;
            }}
            urlLoad={`Extrato/${user.id}`}
            params={{
              busca: search,
              periodo: period.id,
            }}
            displayToolbar={false}
            displayActions={false}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user.data,
});

export default connect(mapStateToProps)(Budget);



// WEBPACK FOOTER //
// ./src/screens/client/profile/Budget.js